import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Loader from "react-loader";
import {fetchedPage, loadPage} from "../../actions/page";
import Title from "../elements/Title";
import HeroImage from "../elements/HeroImage";
import BlockLoop from "../elements/BlockLoop";
import NewsList from "../elements/NewsList";
import TopBar from "../layout/TopBar";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import SideBar from "../navigation/SideBar";

class NewsListPage extends React.Component {

    componentWillUnmount() {
        this.props.loadPage()
    }
    componentDidMount() {
        this.props.fetchedPage('/api' + this.props.location.pathname).then();
    }

    render() {
        const {page, modal, navigation, loaded} = this.props;
        return (
          <Loader loaded={loaded}>
          <div className={"transition-item"}>
              <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                  <TopBar/>
                  <TopNavigation/>
                  <SideBar navigation={navigation}/>
                  <HeroImage {...page.heroImage}  />
                  <Title introTitle={page.title}/>
                  <NewsList cards={page.newsArticles}/>
                  <BlockLoop/>.
                  <Footer/>
              </div>
          </div>
          </Loader>
        )
    };

}

NewsListPage.propTypes = {
    fetchedPage: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        page: state.page,
        modal: state.modal,
        navigation: state.navigation,
        loaded: state.loaded.loaded
    };
}

export default connect(mapStateToProps, {fetchedPage, loadPage})(NewsListPage);




// WEBPACK FOOTER //
// ./src/components/pages/NewsListPage.js